var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 8.50016C9.84225 8.50016 11.3346 7.00778 11.3346 5.16683C11.3346 3.32588 9.84225 1.8335 8.0013 1.8335C6.16035 1.8335 4.66797 3.32588 4.66797 5.16683C4.66797 7.00778 6.16035 8.50016 8.0013 8.50016Z",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.81 10.9933L10.4499 13.3534C10.3566 13.4467 10.2699 13.62 10.2499 13.7467L10.1233 14.6467C10.0766 14.9733 10.3033 15.2 10.6299 15.1533L11.5299 15.0267C11.6566 15.0067 11.8366 14.92 11.9233 14.8267L14.2833 12.4667C14.6899 12.06 14.8833 11.5867 14.2833 10.9867C13.6899 10.3933 13.2166 10.5867 12.81 10.9933Z",
    stroke: "#6F00FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 11.3335C12.6688 12.0535 13.2287 12.6135 13.9487 12.8135",
    stroke: "#6F00FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27344 15.1667C2.27344 12.5867 4.84012 10.5 8.00012 10.5C8.69346 10.5 9.3601 10.6 9.9801 10.7867",
    stroke: "#6F00FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.e1102234211b88c67e794d565343cee7.svg";
export { ForwardRef as ReactComponent };